import Vue from 'vue'
import Vuex from 'vuex'
import API from '@/utils/api'
import {getUserErrorMessage} from '@/utils/api'
import { convertCountryCodeToCountry } from '@/utils/convertor'
import { parsePassportInfo } from '@OLD/functions/amocrm/parsePassportInfo'
import { minLength } from '@/utils/Validate.js'
import { convertYMDtoDMY } from '@/utils/convertor.js'

import objectToFormData from '@/utils/objectToFormData'

const api = new API()

Vue.use(Vuex)

const showLoggedOutMessageIfNeed = (e, commit) => {
  if (   e
      && e.response
      && (401 == e.response.status)
  ) {
    commit('setAlertMsg', '!');
  }
};

export default new Vuex.Store({
  state: {
    // user
    userIsAuth: false,              // состояние аутентификации пользователя
    userData: '',                   // данные пользователя
    userAddressInfo: '',            // прочитанный из json адрес в виде объекта
    currentUserID: null,            // ИД пользователя для просмотра админами

    showAlert: false,

    // toasts
    showToast: false,
    toast: {
      text: "",
      state: 0
    },

    // Wait
    showWait: false,

    // FotoRedactor
    showFotoRedactor: false,
    oldFoto: ''

  },
  mutations: {
    setUserIsAuth(state, data) {
      state.userIsAuth = data
    },
    updateBirthdate(state, bd) {
      if (state.userData.memberInfo) {
        state.userData.memberInfo.birthdate = (bd || null);
      }
    },
    passportScanUploaded(state) {
      if (state.userData.memberInfo) {
        state.userData.memberInfo.isPassportScanUploaded = true;
      }
    },
    requestScanUploaded(state) {
      if (state.userData.memberInfo) {
        state.userData.memberInfo.isRequestScanUploaded = true;
      }
    },
    setDataToast(state, data) {
      state.toast = data
      this.commit('setShowToast', true)
    },
    setShowToast(state, data) {
      state.showToast = data
    },
    setAlertMsg(state, msgHTML) {
      state.alertMsg = msgHTML;
      this.commit('setShowAlertMessage', true)
    },
    setShowAlertMessage(state, isShow) {
      state.showAlert = isShow;
    },
    setShowWait(state, data) {
      state.showWait = data
    },
    setUserData(state, data) {
      state.userData = data
      if (data.memberInfo?.addressInfo) state.userAddressInfo = JSON.parse(data.memberInfo.addressInfo)
    },
    setLastSendConfirmEmailLetter(state, data) {
      state.lastSendConfirmEmailLetter = data
    },
    setShowFotoRedactor(state, data) {
      state.showFotoRedactor = data
    },
    setOldFoto(state, data) {
      state.oldFoto = data
    },
    setCurrentUserID(state, data) {
      state.currentUserID = data
    }
  },
  actions: {
    loginUserWithPass({ commit }, data) {           // логин пользователя с помощью пароля
      return new Promise((resolve, reject) => {
        api.loginUserWithPass(data)
        .then((res) => {
          if (res.success) {
            commit('setUserIsAuth', true)
            this.dispatch('loginWithCookie')
            resolve()
          }
        })
        .catch((e) => {
          reject(e)
          if (e.response.status === 401) e = 'Неверный логин или пароль'
          commit('setDataToast', { state: 1, text: e })
        })
      })
    },
    resetPassword({ commit }, data) {               // отправка нового пароля на почту
      return new Promise((resolve, reject) => {
        api.resetPassword(data)
        .then((/*res*/) => {
          resolve(/*res*/)
          commit('setDataToast', { state: 0, text: "Инструкция отправлена на указанный email" })
        })
        .catch((e) => {
          commit('setDataToast', { state: 1, text: e.response?.data?.errorMessage || e.message }) // e.response?.data?.errorMessage - точно надо?
          reject()
        })
      })
    },
    registrationUser({ commit },  data) {           // регистрация пользователя
      return new Promise((resolve, reject) => {
        api.registrationUser(data)
        .then((res) => {
          if (res.success === true) {
            commit('setDataToast', { state: 2, text: "Вы зарегистрированы" })
          } else {
            commit('setDataToast', { state: 1, text: res.errorMessage })
          }
          resolve(res)
        })
        .catch((e) => {
          commit('setDataToast', { state: 1, text: e })
          reject()
        })
      })
    },
    loginWithCookie({ commit }) {                   // логин по куки
      return new Promise((resolve, reject) => {
        commit('setShowWait', true)

        api.loginWithCookie()
        .then((res) => {
          commit('setShowWait', false)
          commit('setUserIsAuth', true)
          commit('setUserData', res)
          resolve()
        })
        .catch(() => {
          commit('setShowWait', false)
          reject()
        })
      })
    },
    sendConfirmEmailLetter({ commit }) {            // отправка проверочного кода для подтверждения email
      return new Promise((resolve, reject) => {
        commit('setShowWait', true)
        const formData = new FormData()
        formData.append('email', this.getters.getUserData.email)

        api.sendConfirmEmailLetter(formData)
        .then((/*res*/) => {
          commit('setShowWait', false)
          commit('setDataToast', { state: 0, text: "Проверочный код отправлен на указанный email!" })
          resolve()
          //console.log(res)
        })
        .catch((e) => {
          commit('setDataToast', { state: 1, text: e.response?.data?.errorMessage || e })
          commit('setShowWait', false)
          reject()
        })
      })
    },
    saveInfo({ commit }, data) {                    // сохранение данных пользователя
      return new Promise((resolve, reject) => {
        commit('setShowWait', true)
        data.append('email', this.getters.getUserData.email)
        data.append('id', this.getters.getUserData.id)
        // if (this.getters.getCurrentUserID) data.append('current_user', this.getters.getCurrentUserID)

        api.saveInfo(data)
        .then((/*res*/) => {
          commit('setShowWait', false)
          const bd = data.get('birthdate');
          if (null !== bd) {
            this.commit('updateBirthdate', bd);
          }
          resolve()
          //console.log(res)
        })
        .catch((e) => {
          showLoggedOutMessageIfNeed(e, commit);
          commit('setDataToast', { state: 1, text: getUserErrorMessage(e) || e })
          commit('setShowWait', false)
          reject()
        })
      })
    },
    disableAutoprolongation({ commit }, savedPaymentMethodData) {
      const data = objectToFormData({
        email: this.getters.getUserData.email,
        id:    this.getters.getUserData.id,
        savedPaymentMethodData: JSON.stringify( savedPaymentMethodData ),
      });

      api.disableAutoprolongation(data)
        .then(() => {
          window.location.reload();
        })
        .catch((e) => {
          showLoggedOutMessageIfNeed(e, commit);
        });
    },
    savePhoto({ commit }, data) {                   // сохранение фото
      return new Promise((resolve, reject) => {
        commit('setShowWait', true)
        data.append('email', this.getters.getUserData.email)
        data.append('id', this.getters.getUserData.id)

        api.savePhoto(data)
        .then(() => {
          commit('setShowWait', false);
          resolve();
        })
        .catch((e) => {
          showLoggedOutMessageIfNeed(e, commit);
          commit('setDataToast', { state: 1, text: e });
          commit('setShowWait', false);
          reject()
        })
      })
    },
    payEntry({ commit }, data) {                    // сохранение заявки на оплату членства
      commit('setShowWait', true)

      data.append('email', this.getters.getUserData.email)
      data.append('id', this.getters.getUserData.id)

      return new Promise((resolve, reject) => {
        api.payEntry(data)
        .then((res) => {
          commit('setShowWait', false)
          // console.log(res)
          // this.dispatch('loginWithCookie')
          resolve(res)
        })
        .catch((e) => {
          showLoggedOutMessageIfNeed(e, commit);
          commit('setDataToast', { state: 1, text: getUserErrorMessage(e) || e })
          commit('setShowWait', false)
          reject()
        })
      })
    },
    payForMembership({ commit }, data) {            // для оплаты членства:
      commit('setShowWait', true)

      return new Promise((resolve, reject) => {
        api.payForMembership(data)
        .then((res) => {
          commit('setShowWait', false)
          resolve(/*res*/)
          window.location.href = res.url
        })
        .catch((e) => {
          showLoggedOutMessageIfNeed(e, commit);
          commit('setDataToast', { state: 1, text: getUserErrorMessage(e) || e })
          commit('setShowWait', false)
          reject()
        })
      })
    },
    savePassportScan({ commit }, data) {
      commit('setShowWait', true)

      data.append('email', this.getters.getUserData.email)
      data.append('id', this.getters.getUserData.id)

      return new Promise((resolve, reject) => {
        api.savePassportScan(data)
        .then(() => {
          commit('setShowWait', false)
          commit('passportScanUploaded')
          resolve(/*res*/)
        })
        .catch((e) => {
          showLoggedOutMessageIfNeed(e, commit);
          commit('setDataToast', { state: 1, text: e })
          commit('setShowWait', false)
          reject()
        })
      })
    },
    saveRequestScan({ commit }, data) {
      commit('setShowWait', true)

      data.append('email', this.getters.getUserData.email)
      data.append('id', this.getters.getUserData.id)

      return new Promise((resolve, reject) => {
        api.saveRequestScan(data)
        .then(() => {
          commit('setShowWait', false)
          commit('requestScanUploaded')
          resolve(/*res*/)
        })
        .catch((e) => {
          showLoggedOutMessageIfNeed(e, commit);
          commit('setDataToast', { state: 1, text: e })
          commit('setShowWait', false)
          reject()
        })
      })
    },
    sendPhoneVerifyCode({ commit }, phone) {
      const formData = new FormData();
      formData.append('email', this.getters.getUserData.email)
      formData.append('id', this.getters.getUserData.id)
      formData.append('memberId', this.getters.getUserData.memberInfo?.id)
      formData.append('phone', phone);

      commit('setShowWait', true)

      return api.sendPhoneVerifyCode(formData)
          .then((r) => {
            commit('setShowWait', false)
            return r;
          })
          .catch((e) => {
            commit('setShowWait', false)
            commit('setDataToast', { state: 1, text: getUserErrorMessage(e) || e })
            throw e;
          })
    },
    confirmPhoneByCode({ commit }, {phone, code}) {
      const formData = new FormData();
      formData.append('email', this.getters.getUserData.email)
      formData.append('id', this.getters.getUserData.id)
      formData.append('memberId', this.getters.getUserData.memberInfo?.id)
      formData.append('phone', phone);
      formData.append('code', code);

      commit('setShowWait', true)

      return api.confirmPhoneByCode(formData)
          .then((r) => {
            commit('setShowWait', false)
            return r;
          })
          .catch((e) => {
            commit('setShowWait', false)
            commit('setDataToast', { state: 1, text: getUserErrorMessage(e) || e })
            throw e;
          })
    },

    // confirmEmail({ commit }, data) {             // подтверждение email
    //   return new Promise((resolve, reject) => {
    //     commit('setShowWait', true)

    //     api.confirmEmail(data)
    //     .then((res) => {
    //       commit('setShowWait', false)
    //       commit('setDataToast', { state: 2, text: "Регистрация завершена!" })
    //       resolve()
    //       console.log(res)
    //     })
    //     .catch((e) => {
    //       console.dir(e)
    //       if (e.respone.status === 406) e = e.response.data.errorMessage
    //       commit('setDataToast', { state: 1, text: e })
    //       commit('setShowWait', false)
    //       reject()
    //     })
    //   })
    // }
  },
  getters: {
    getUserIsAuth: s => s.userIsAuth,
    getShowToast: s => s.showToast,
    getShowAlert: s => s.showAlert,
    getToastData: s => s.toast,
    getShowWait: s => s.showWait,
    getUserData: s => s.userData,
    getShowFotoRedactor: s => s.showFotoRedactor,
    getOldFoto: s => s.oldFoto,
    getUserAddressInfo: s => s.userAddressInfo,
    getUserAddressInfoString: s => {
        if (!s.userAddressInfo) {
            return "";
        }

        return [
            (s.userAddressInfo['zip']),
            convertCountryCodeToCountry(s.userAddressInfo['country']),
            (s.userAddressInfo['city']),
            (s.userAddressInfo['address_line_1']),
            (s.userAddressInfo['address_line_2']),
        ].filter(line => typeof line === 'string').filter(line => line.length).join(', ').replace(/,,/, ',');
    },
    getCurrentUserID: s => s.currentUserID,
    isUserPassportDataFilled: (s, getters) => {
      return !!getters.userPassportDataString;
    },
    userPassportDataString: (s, getters) => {
      const dateOfBirth = getters.getUserData.memberInfo?.birthdate || '';
      const passportInfo = getters.getUserData.memberInfo?.passportInfo || '';

      if (minLength(dateOfBirth)) return false;
      const passInfo = parsePassportInfo(passportInfo)

      if (!passInfo && passportInfo.length > 0) {
        return passportInfo;
      } else if (passInfo) {
        if (!(minLength(passInfo.number)
          || minLength(passInfo.series)
          || minLength(passInfo.whom)
          || minLength(passInfo.when))) {
            return passInfo.series + ' ' + passInfo.number + ', выдан ' + passInfo.whom + ' ' + convertYMDtoDMY(passInfo.when || '')
        }
      } else {
        return false;
      }
    },
    isUserDataFilled: (s, getters) => {
      return !(
        (getters.getUserData.memberInfo?.lastname || '') === '' ||
        (getters.getUserData.memberInfo?.firstname || '') === '' ||
        (getters.getUserData.memberInfo?.middlename || '') === '' ||
        (getters.getUserData.memberInfo?.nameForCard || '') === ''
      );
    },
    userDataString: (s, getters) => {
      return [
        getters.getUserData.memberInfo?.lastname,
        getters.getUserData.memberInfo?.firstname,
        getters.getUserData.memberInfo?.middlename,
        getters.getUserData.memberInfo?.nameForCard,
      ].filter(s => !!s).join(' ');
    },
    isUserContactDataFilled: (s, getters) => {
      return !!getters.userContactDataStrings;
    },
    userContactDataStrings: (s, getters) => {
      const memberInfo = getters.getUserData.memberInfo;
      const addressInfo = getters.getUserAddressInfo;

      if (!memberInfo || !addressInfo) {
        return false;
      }

      if (memberInfo.emails?.length && memberInfo.phones?.length && addressInfo.country && addressInfo.city && addressInfo.zip && addressInfo.address_line_1) {
        return [
          [addressInfo.zip, (addressInfo.country === 'RU') ? '' : addressInfo.country, addressInfo.state, addressInfo.city, addressInfo.address_line_1, addressInfo.address_line_2].filter(s => !!s).join(', ').replace(',,', ','),
          memberInfo.phones.map(e => e.value).join(', '),
          memberInfo.emails.map(e => e.value).join(', '),
        ];
      }

      return false;
    },
    shouldBeRedirectedToEntrancePage: (s, getters) => {
      return !getters.getUserData.memberInfo || getters.getUserData.memberInfo.status != 'active_member';
    },
  }
})
